import React from 'react';
import './App.css';
import SearchPhotos from "./searchPhotos";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    return (
        <div className="App"> <div> Hello World! </div>
            <div className="container">
                <SearchPhotos/>
            </div>
        </div>
    );
}

export default App;
